import { z } from 'zod';
export var postTokenCreateBodyRequestSchema = z.object({
    hash: z.string(),
});
export var postTokenCreateBodyResponseSchema = z.object({
    token: z.string(),
});
